import { EuiSpacer } from '@elastic/eui';
import VideoCard from "../../../../src/components/Internet_Access/Videos/video-port-forwarding-vodafone";
import * as React from 'react';
export default {
  EuiSpacer,
  VideoCard,
  React
};